import React from "react";

const CornerMedium = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.11111C0 2.21137 4.10891 0 7.11111 0H15.1111C15.602 0 16 0.397969 16 0.888889C16 1.37981 15.602 1.77778 15.1111 1.77778H7.11111C4.77998 1.77778 1.77778 3.47752 1.77778 7.11111V15.1111C1.77778 15.602 1.37981 16 0.888889 16C0.397969 16 0 15.602 0 15.1111V7.11111Z"
      fill="currentColor"
    />
  </svg>
);

export default CornerMedium;
